export type PrizmDecimalSymbol = '.' | ',';
